/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsGetGipReportEvidenceExportUrlQueryResponse, AuditReportsGetGipReportEvidenceExportUrlPathParams, AuditReportsGetGipReportEvidenceExportUrl401, AuditReportsGetGipReportEvidenceExportUrl403, AuditReportsGetGipReportEvidenceExportUrl404 } from "../models/AuditReportsGetGipReportEvidenceExportUrl";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { auditReportsGetGipReportEvidenceExportUrl } from "../axios/auditReportsGetGipReportEvidenceExportUrl";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const auditReportsGetGipReportEvidenceExportUrlQueryKey = (id: AuditReportsGetGipReportEvidenceExportUrlPathParams["id"]) => ["api-v2", { url: '/audit-reports/v1/reports/gip/report/:id/evidence-export-url', params: {id:id} }] as const

export type AuditReportsGetGipReportEvidenceExportUrlQueryKey = ReturnType<typeof auditReportsGetGipReportEvidenceExportUrlQueryKey>

export function auditReportsGetGipReportEvidenceExportUrlQueryOptions(id: AuditReportsGetGipReportEvidenceExportUrlPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = auditReportsGetGipReportEvidenceExportUrlQueryKey(id)
        return queryOptions<AuditReportsGetGipReportEvidenceExportUrlQueryResponse, ResponseErrorConfig<AuditReportsGetGipReportEvidenceExportUrl401 | AuditReportsGetGipReportEvidenceExportUrl403 | AuditReportsGetGipReportEvidenceExportUrl404>, AuditReportsGetGipReportEvidenceExportUrlQueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return auditReportsGetGipReportEvidenceExportUrl(id, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Get export URL for existing report
 * {@link /audit-reports/v1/reports/gip/report/:id/evidence-export-url}
 */
export function useAuditReportsGetGipReportEvidenceExportUrl<TData = AuditReportsGetGipReportEvidenceExportUrlQueryResponse, TQueryData = AuditReportsGetGipReportEvidenceExportUrlQueryResponse, TQueryKey extends QueryKey = AuditReportsGetGipReportEvidenceExportUrlQueryKey>(id: AuditReportsGetGipReportEvidenceExportUrlPathParams["id"], options: 
{
  query?: Partial<QueryObserverOptions<AuditReportsGetGipReportEvidenceExportUrlQueryResponse, ResponseErrorConfig<AuditReportsGetGipReportEvidenceExportUrl401 | AuditReportsGetGipReportEvidenceExportUrl403 | AuditReportsGetGipReportEvidenceExportUrl404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? auditReportsGetGipReportEvidenceExportUrlQueryKey(id)
         

         const query = useQuery({
          ...auditReportsGetGipReportEvidenceExportUrlQueryOptions(id, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<AuditReportsGetGipReportEvidenceExportUrl401 | AuditReportsGetGipReportEvidenceExportUrl403 | AuditReportsGetGipReportEvidenceExportUrl404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}